import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { formatToCurrency, formatToDateString } from '../../util/formatting';
import { undefinedCheck } from '../../util/undefinedCheck';
import '@mantine/charts/styles.css';
import { Title } from '../../components/Title';
import { ExportButton } from '../export/ExportButton';
import type { RxCountDto } from './types/RxCountDto';
import { KeyedRow } from '../../components/KeyedRow';

export function RxCounts() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const eodLogsQuery = queryWithFilterAndPages<RxCountDto[]>(
		`${organisation}/rx-counts/all`,
		filter.value,
		pagination.value,
	);

	const eodLogsCountQuery = queryWithFilter<number>(
		`${organisation}/rx-counts/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader
				title={'RX Counts'}
				filter={filter}
				filterOnSameLine
				rightContent={
					<ExportButton apiPath={`${organisation}/rx-counts/export`} />
				}
			/>
			<DataTable
				pagination={pagination}
				totalItems={eodLogsCountQuery.data?.value ?? 100}
				isRowsLoading={eodLogsQuery.isLoading}
				isPaginationLoading={eodLogsCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th miw={'15vw'}><Title label={'Date'} /></Table.Th>
						<Table.Th><Title label={'Branch'} /></Table.Th>
						<Table.Th><Title label={'Till'} /></Table.Th>
						<Table.Th><Title label={'Operator'} /></Table.Th>
						<Table.Th><Title label={'Cash'} /></Table.Th>
						<Table.Th><Title label={'Safe'} /></Table.Th>
						<Table.Th><Title label={'Paid Forms'} /></Table.Th>
						<Table.Th><Title label={'Paid Items'} /></Table.Th>
						<Table.Th><Title label={'Exempt Forms'} /></Table.Th>
						<Table.Th><Title label={'Exempt Items'} /></Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{eodLogsQuery.data?.value.map((eodLogsQuery) => (
						<KeyedRow key={eodLogsQuery.id}>
							<Table.Td>{formatToDateString(eodLogsQuery.dateTime)}</Table.Td>
							<Table.Td>{undefinedCheck(eodLogsQuery.branch)}</Table.Td>
							<Table.Td>{undefinedCheck(eodLogsQuery.till)}</Table.Td>
							<Table.Td>{undefinedCheck(eodLogsQuery.operator)}</Table.Td>
							<Table.Td>{formatToCurrency(eodLogsQuery.cash)}</Table.Td>
							<Table.Td>{formatToCurrency(eodLogsQuery.safe)}</Table.Td>
							<Table.Td>{eodLogsQuery.paidForms}</Table.Td>
							<Table.Td>{eodLogsQuery.paidItems}</Table.Td>
							<Table.Td>{eodLogsQuery.exemptForms}</Table.Td>
							<Table.Td>{eodLogsQuery.exemptItems}</Table.Td>
						</KeyedRow>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
